<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">稼動率日誌</div>
      <div style="margin-top: 2rem">
        <div class="row">
          <div class="col-12 col-xxl-7">
            <commonQueryInput
              :inputItems="multiInputItems"
              v-model:getValue="multiInputVal"
            ></commonQueryInput>
          </div>
          <div
            v-if="deviceData.length > 0"
            class="col-12 col-xxl-5 align-self-end text-end pb-2"
          >
            <div class="mt-3 ml-2" style="display: inline-block; width: 170px">
              <div
                style="
                  display: inline-block;
                  background-color: #f2f2f2;
                  color: var(--main-status-success-color);
                  padding: 5px 10px 5px 10px;
                "
              >
                良好
              </div>
              <div style="display: inline-block; width: 110px">
                稼動率85%以上
              </div>
            </div>
            <div class="mt-3 ml-2" style="display: inline-block; width: 170px">
              <div
                style="
                  display: inline-block;
                  background-color: #f2f2f2;
                  color: var(--main-status-warning-color);
                  padding: 5px 10px 5px 10px;
                "
              >
                注意
              </div>
              <div style="display: inline-block; width: 110px">
                稼動率85%以下
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row mx-0 activation-row overflow-auto"
        style="max-height: 650px"
      >
        <template v-for="col in 2" :keys="col">
          <div class="col-12 col-xxl-6 px-0">
            <div class="row mx-0">
              <template v-for="index in colCount" :keys="index">
                <template
                  v-if="
                    deviceData[[index - 1 + (col - 1) * colCount]] != undefined
                  "
                >
                  <commonColCard
                    :colTitleTop="{
                      'activation-col-title-name-R':
                        deviceData[index - 1 + (col - 1) * colCount]
                          .device_activation >= 85,
                      'activation-col-title-name-Q':
                        deviceData[index - 1 + (col - 1) * colCount]
                          .device_activation < 85,
                    }"
                    :colTitleBottom="{
                      'activation-col-title-status-R':
                        deviceData[index - 1 + (col - 1) * colCount]
                          .device_activation >= 85,
                      'activation-col-title-status-Q':
                        deviceData[index - 1 + (col - 1) * colCount]
                          .device_activation < 85,
                    }"
                  >
                    <template #col-title-top>
                      {{
                        deviceData[index - 1 + (col - 1) * colCount].device_name
                      }}</template
                    >
                    <template #col-title-bottom>
                      {{
                        deviceData[index - 1 + (col - 1) * colCount]
                          .device_activation >= 85
                          ? "良好"
                          : "注意"
                      }}</template
                    >
                    <template #col-title-body>
                      <div class="row mx-0">
                        <div
                          class="col-12 px-0 d-flex justify-content-between activation-col-detail"
                        >
                          <div>
                            <span
                              >待機時間:{{
                                deviceData[index - 1 + (col - 1) * colCount]
                                  .device_queue_time
                              }}</span
                            >
                          </div>
                          <div>
                            <span>
                              機型:{{
                                deviceData[index - 1 + (col - 1) * colCount]
                                  .device_model
                              }}
                            </span>
                          </div>
                          <div>
                            <span>稼動率:</span>
                            <span>{{
                              deviceData[index - 1 + (col - 1) * colCount]
                                .device_activation + "%"
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="row mx-0">
                        <div
                          class="col-12 px-0 d-flex justify-content-between activation-col-detail"
                        >
                          <stackBar
                            :stacksBarClass="stacksBarClass"
                            :stacksBarMaxValue="stacksBarMaxValue"
                            :stacksData="
                              deviceData[index - 1 + (col - 1) * colCount]
                                .stack_bar_information
                            "
                            :stacksSize="'midle'"
                          />
                        </div>
                      </div>
                    </template>
                  </commonColCard>
                </template>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import queryResultTable from "@/components/queryResultTable.vue";
import radioButtonChart from "@/components/radioButtonChart.vue";
import commonColCard from "@/components/commonColCard.vue";
import commonTable from "@/components/commonTable.vue";
import stackBar from "@/components/stackBar.vue";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    queryResultTable,
    radioButtonChart,
    commonColCard,
    commonTable,
    stackBar,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const actOper = computed(() => store.getters["selectOptions/get_actOper"]);
    const group = computed(() => store.getters["selectOptions/get_group"]);
    const stacksBarClass = computed(
      () => store.getters["stackBar/get_stacksBarClass"]
    );
    const stacksBarMaxValue = computed(
      () => store.getters["stackBar/get_stacksBarMaxValue"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const path = inject("path");
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "date",
        label: "日期",
        type: "date", // date/dateBetween/text/select/
      },
      {
        key: "oper",
        label: "製程",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇製程 --",
        options: actOper,
      },
      {
        key: "group",
        label: "組別",
        type: "select",
        bindKey: "oper",
        checkEmpty: false,
        disableText: "-- 選擇組別 --",
        bindOptions: group,
      },
    ]);

    const colCount = ref(0);
    const deviceData = ref([]);

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        if (
          newValue["oper"] != 8 &&
          (newValue["group"] == undefined || newValue["group"] == "")
        ) {
          methods.setTimeoutAlert("請選擇組別");
          return;
        }
        methods.triggerLoadingBar();
        let params = {};
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = path.value;
        console.log(path.value);
        params["methods"] = "POST";
        params["whichFunction"] = "GetActivationLog";
        params["startTime"] = newValue["date"]["startDate"] + " 00:00:00";
        params["endTime"] = newValue["date"]["endDate"] + " 23:59:59";
        params["oper"] = newValue["oper"];
        params["group"] = newValue["group"];

        methods.axiosAction(params).then(() => {
          console.log(axiosResult.value);
          let result = axiosResult.value;
          let response = result.Response;
          if (response == "ok") {
            let queryTableData = result.QueryTableData[0];
            colCount.value = Math.ceil(
              Object.keys(queryTableData.deviceData).length / 2
            );
            console.log(colCount.value);
            deviceData.value = queryTableData.deviceData;
          } else {
            deviceData.value = [];
            methods.setTimeoutAlert(response);
          }
          methods.triggerLoadingBar();
        });
      },
      { deep: true }
    );

    return {
      stacksBarClass,
      stacksBarMaxValue,
      multiInputVal,
      multiInputItems,
      colCount,
      deviceData,
    };
  },
};
</script>

<style>
.activation-row > div:first-child > div .common-col-card {
  border-right: none;
}
.activation-row > div > div .common-col-card {
  border-bottom: none;
}
.activation-row > div > div .common-col-card:last-child {
  border-bottom: 1px solid rgb(204, 204, 204);
}
.activation-col-title-name-R {
  /* 運作 */
  background-color: var(--main-status-success-color);
  color: var(--main-font-color);
}
.activation-col-title-name-Q {
  /* 待機 */
  background-color: var(--main-status-warning-color);
  color: var(--main-font-color);
}
.activation-col-title-status-R {
  background-color: #f2f2f2;
  color: var(--main-status-success-color);
}
.activation-col-title-status-Q {
  background-color: #f2f2f2;
  color: var(--main-status-warning-color);
}
.activation-col-detail {
  overflow-x: auto;
}
.activation-col-detail > div {
  white-space: nowrap;
}
.activation-col-detail::-webkit-scrollbar {
  display: none;
}

.activation-row
  > div:first-child
  > div
  .common-col-card:last-child:only-of-type {
  border-right: 1px solid rgb(204, 204, 204);
  border-bottom: 1px solid rgb(204, 204, 204);
}
@media screen and (max-width: 1400px) {
  .activation-row > div:first-child > div .common-col-card:last-child {
    border-bottom: none;
  }
  .activation-row > div:first-child > div .common-col-card {
    border-right: 1px solid rgb(204, 204, 204);
  }
}
</style>
